import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FindWork from "../pages/find-work/page";
import Hire from "../pages/hire/page";
import Pricing from "../pages/pricing/page";
import About from "../pages/about/page";
import HowItWorks from "../pages/how-it-works/page";
import Capabilities from "../pages/capabilities/page";
import Dashboard from "../pages/dashboard/page";
import JobDetail from "../pages/jobs/page";
import Signup from "../pages/signup/page";
import Login from "../pages/login/page";
import WorkerProfile from "../pages/account/worker/page";
import EmployerProfile from "../pages/account/employer/page";
import EmployerDashboard from "../pages/dashboard/employer/page";
import Checkout from "../pages/checkout/page";
import Legal from "../pages/legal/page";

const routes: RouteObject[] = [
  { path: "/",                   element: <Home />              },
  { path: "/find-work",          element: <FindWork />          },
  { path: "/hire",               element: <Hire />              },
  { path: "/pricing",            element: <Pricing />           },
  { path: "/about",              element: <About />             },
  { path: "/how-it-works",       element: <HowItWorks />        },
  { path: "/capabilities",       element: <Capabilities />      },
  { path: "/dashboard",          element: <Dashboard />         },
  { path: "/dashboard/employer", element: <EmployerDashboard /> },
  { path: "/jobs/:id",           element: <JobDetail />         },
  { path: "/signup",             element: <Signup />            },
  { path: "/login",              element: <Login />             },
  { path: "/account/worker",     element: <WorkerProfile />     },
  { path: "/account/employer",   element: <EmployerProfile />   },
  { path: "/checkout",           element: <Checkout />          },
  { path: "/legal",              element: <Legal />             },
  { path: "*",                   element: <NotFound />          },
];

export default routes;
